"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadBox = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const upload_box_styles_1 = require("./upload-box.styles");
const icons_1 = require("../../../icons");
const localization_1 = require("../../../localization");
const UploadBox = ({ id, fileType, disabled, onChange, }) => {
    var _a, _b;
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const ref = (0, react_1.useRef)(null);
    const handleChange = (e) => {
        var _a;
        if ((_a = e.target.files) === null || _a === void 0 ? void 0 : _a.length) {
            // TODO: allow the user to upload more than one file
            const file = e.target.files[0];
            // TODO: allow the user to specify a Catalog name
            const newItem = { id: `${Date.now()}-${file.name}`, file };
            onChange(newItem);
        }
    };
    const fileName = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.files[0]) === null || _b === void 0 ? void 0 : _b.name;
    return (react_1.default.createElement(upload_box_styles_1.StyledUploadBoxContainer, null, react_1.default.createElement(icons_1.CSVDocumentIcon, { fill: ui_components_1.baseColors.primaryTeal100, stroke: ui_components_1.baseColors.primaryGreen300 }), react_1.default.createElement(material_1.FormControl, { className: "upload-button-container", component: "div" }, react_1.default.createElement(ui_components_1.Typography, { variant: "body2", color: "textSecondary" }, fileName), react_1.default.createElement(material_1.FormLabel, { className: "upload-button-label", htmlFor: id }, react_1.default.createElement(upload_box_styles_1.StyledButton, { variant: "outlined", rounded: true, title: t({ key: fileName ? 'REPLACE_FILE' : 'CHOOSE_FILE' }) })), react_1.default.createElement("input", { ref: ref, type: "file", className: "file-upload-input", accept: fileType, id: id, disabled: disabled, onChange: handleChange }))));
};
exports.UploadBox = UploadBox;
exports.default = exports.UploadBox;
